import { schema } from 'normalizr';
import { user } from './user';
import { questionnaireTemplate } from './questionnaireTemplate';
import { company } from './company';

export const questionnaire = new schema.Entity('questionnaires', {
  contactUser: user,
  template: questionnaireTemplate,
  company,
});

export const questionnaires = new schema.Array(questionnaire);
